// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chat-overtime__text[data-v-ffbaa720] {\n  margin-bottom: 5px;\n  color: #f93;\n  font-size: 14px;\n}\n", ""]);
// Exports
module.exports = exports;
